export default __webpack_public_path__ + "static/media/php.2c2c5009.png";